module.exports = __webpack_public_path__ + "img/icon-menu-faq.0fe90d1c.svg";